<template>
  <div class="d-flex app-container">
    <navigator :flag="navFlag" class="nav-section" />
    <div v-if="isModalOpen" class="modal-overlay"></div>

    <OnboardingWrapper class="main-content-wrapper">
      <div id="search-surveys" class="discover-page">
        <div class="header-section">
          <div id="discover-header-card" class="header-card">
            <div class="card-head-container">
              <div class="card-title-container title-header">
                <h2 class="discover-title">Discover projects</h2>
              </div>
            </div>

            <div class="w-100 header-card-content">
              <div id="search-bar-step">
                <b-form-input v-model="searchTerm" placeholder="Search by name" class="text-input"></b-form-input>
              </div>

              <div class="card-title-container mt-4">
                <h6 class="adv-search-title">Advanced Search</h6>
              </div>
              <hr class="divider" />

              <div v-if="selectedTags.length > 0" class="selected-tags-wrapper">
                <div class="d-flex flex-wrap justify-content-start tag-selector">
                  <b-button @click="clearAllTags()" class="clear-all-button" size="sm">Clear All</b-button>
                  <b-button v-for="tag in selectedTags" :key="tag" class="tag-button-chosen" @click="removeSelectedTag(tag)" size="sm">{{ tag }}</b-button>
                </div>
                <hr class="divider" />
              </div>

              <details class="tag-dropdown">
                <summary class="tag-category-header">Platform</summary>
                <div class="tag-options">
                  <button v-for="opt in platformOptions" :key="opt" :class="['tag-btn', { 'selected': selectedTags.includes(opt) }]" @click="toggleTag(opt)">{{ opt }}</button>
                </div>
              </details>

              <details class="tag-dropdown">
                <summary class="tag-category-header">Behavior</summary>
                <div class="tag-options">
                  <button v-for="opt in behaviorOptions" :key="opt" :class="['tag-btn', { 'selected': selectedTags.includes(opt) }]" @click="toggleTag(opt)">{{ opt }}</button>
                </div>
              </details>

              <details class="tag-dropdown">
                <summary class="tag-category-header">Genre</summary>
                <div class="tag-options">
                  <button v-for="opt in genreOptions" :key="opt" :class="['tag-btn', { 'selected': selectedTags.includes(opt) }]" @click="toggleTag(opt)">{{ opt }}</button>
                </div>
              </details>
            </div>
          </div>
        </div>

        <div class="content-section">
          <GridViewDiscover v-if="gridView" :games="searchGames" :surveys="searchSurvey" @delete-survey="deleteSurvey" @modal-state-changed="handleModalStateChange" />
          <ListViewDiscover v-else :games="searchGames" :surveys="searchSurvey" @delete-survey="deleteSurvey" @modal-state-changed="handleModalStateChange" />
        </div>
      </div>
    </OnboardingWrapper>
  </div>
</template>

<script>
import navigator from "../layout/NavBarNew.vue";
import GridViewDiscover from "./discover-components/GridViewDiscover.vue";
import ListViewDiscover from "./discover-components/ListViewDiscover.vue";
import OnboardingWrapper from "../onboarding/OnboardingWrapper.vue";
import Template from "../../Firestore/Template";

export default {
  components: { navigator, GridViewDiscover, ListViewDiscover, OnboardingWrapper },
  data() {
    return {
      navFlag: 2,
      userId: window.localStorage.getItem("userId"),
      userType: parseInt(window.localStorage.getItem("userType") || -1),
      selectedTags: [],
      gridView: false,
      isModalOpen: false,
      searchTerm: "",
      surveys: [],
      games: [],
      platformOptions: ["Mobile", "Game Console", "PC/Laptop", "Handheld", "VR"],
      behaviorOptions: ["Competition", "Completion", "Community/Social", "Design", "Destruction", "Fantasy", "Story"],
      genreOptions: ["Action", "Adventure", "Casual/Puzzle", "Multiplayer Online", "Role Playing Game", "Shooter", "Simulation", "Sports", "Strategy"],
    };
  },
  computed: {
    searchSurvey() { return this.filterItems(this.surveys); },
    searchGames() { return this.filterItems(this.games); }
  },
  mounted() { this.loadData(); },
  methods: {
    filterItems(items) {
      return items.filter(item => {
        const name = (item.name || item.gameName || "").toLowerCase();
        const matchesName = name.includes(this.searchTerm.toLowerCase());
        if (this.selectedTags.length === 0) return matchesName;
        const allTags = [...(item.tags || []), ...(item.platform || []), ...(item.behavior || []), ...(item.genre || [])];
        return matchesName && this.selectedTags.some(t => allTags.includes(t));
      });
    },
    loadData() {
      if (this.userType === 0) {
        this.gridView = true;
        Template.getAllGamesForTester(this.userId).then(res => this.games = res.data);
      } else if (this.userType === 1) {
        Template.getSurveysOfDev(this.userId).then(res => this.surveys = res.data);
      } else {
        Template.getAllSurveys().then(res => this.surveys = res.data);
      }
    },
    toggleTag(tag) {
      const i = this.selectedTags.indexOf(tag);
      i > -1 ? this.selectedTags.splice(i, 1) : this.selectedTags.push(tag);
    },
    clearAllTags() { this.selectedTags = []; },
    removeSelectedTag(tag) { this.selectedTags = this.selectedTags.filter(t => t !== tag); },
    deleteSurvey(s) { Template.deleteSurvey(s.sID).then(() => this.loadData()); },
    handleModalStateChange(val) { this.isModalOpen = val; }
  }
};
</script>

<style scoped>
.app-container { height: 100vh; width: 100vw; overflow: hidden; }
.main-content-wrapper { flex: 1; height: 100%; overflow-y: auto; background-color: #eeeeee; }

/* Fixed the container to ensure sidebar doesn't collapse */
.discover-page { 
  display: flex; 
  padding: 1.5rem; 
  gap: 2rem; 
  align-items: flex-start;
}

/* Header section width locked to the image reference */
.header-section { 
  flex: 0 0 520px; /* Do not grow, do not shrink, stay at 350px */
  min-width: 300px; 
  position: sticky; 
  top: 1.5rem; 
}

.header-card { 
  background: white; 
  border-radius: 30px; 
  padding: 1.75rem; 
  box-shadow: 0 4px 12px rgba(0,0,0,0.05); 
}

.content-section { 
  flex: 1; 
  min-width: 0; 
}

.discover-title, .adv-search-title { color: #ff7222; font-weight: bold; }
.text-input.form-control { background: #eee !important; border-radius: 10px !important; border: none; padding: 0.75rem; }

/* Dropdown Styles */
.tag-dropdown { margin-bottom: 0.5rem; border-bottom: 1px solid #eee; }
.tag-category-header { font-weight: 600; cursor: pointer; list-style: none; display: flex; justify-content: space-between; padding: 0.5rem 0; }
.tag-category-header::after { content: '▲'; font-size: 0.6rem; color: #ff7222; transition: 0.2s; }
.tag-dropdown[open] .tag-category-header::after { transform: rotate(180deg); }
.tag-options { display: flex; flex-wrap: wrap; gap: 0.5rem; padding: 0.5rem 0 1.25rem; }

.tag-btn { padding: 0.4rem 0.9rem; border: 1px solid #ddd; background: white; border-radius: 20px; font-size: 0.85rem; transition: 0.2s; }
.tag-btn.selected { background: #ff7222; color: white; border-color: #ff7222; }

.clear-all-button { background-color: #6c757d; border: none; border-radius: 8px; }
.tag-button-chosen { background: #db3360 !important; border: none; color: white; margin: 2px; border-radius: 8px; }

@media (max-width: 992px) { 
  .discover-page { flex-direction: column; align-items: stretch; } 
  .header-section { flex: none; width: 100%; min-width: 100%; position: static; } 
}
</style>


// WEBPACK FOOTER //
// src/components/discover-projects/Discover.vue